"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function parseCookie(tokenArgs) {
    var tokenStr = '';
    var name = tokenArgs.name, value = tokenArgs.value, optionalArgs = __rest(tokenArgs, ["name", "value"]);
    tokenStr = name + "=" + value + ";";
    Object.keys(optionalArgs).forEach(function (key) {
        tokenStr += " " + key + "=" + optionalArgs[key] + ";";
    });
    return tokenStr;
}
exports.parseCookie = parseCookie;
function generateState() {
    return Math.random().toString(32).slice(2);
}
exports.generateState = generateState;
//# sourceMappingURL=store_util.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/util/store_util.js